import React from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  FormErrorIcon,
} from '@chakra-ui/react';
import { TeamNameFieldProps } from '../types';

export const TeamNameField = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  initialFocusRef,
}: TeamNameFieldProps) => (
  <FormControl
    isRequired
    isInvalid={!!(errors.name && touched.name)}
    data-testid='create-team-name-field'
  >
    <FormLabel htmlFor='team-name'>Name</FormLabel>
    <Input
      id='team-name'
      name='name'
      value={values.name}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder='Enter group name'
      ref={initialFocusRef}
      data-testid='create-team-name-input'
    />
    {errors.name && touched.name && (
      <FormErrorMessage data-testid='create-team-name-error'>
        <FormErrorIcon />
        {errors.name}
      </FormErrorMessage>
    )}
  </FormControl>
);
